export default "__VITE_ASSET__v4yicHa5__"